import React from 'react'
import {Card, Grid, Header, Label} from 'semantic-ui-react'
import {resume} from './resume'

export default class Education extends React.Component {
    SchoolInfo = () => {
        const eduInfo = resume.education;            
        return (
            <Grid divided='vertically' className='education'>
                {eduInfo.map((key,id) => {
                    return (
                        <Grid.Row key={id}>
                            <Grid.Column textAlign='left'>
                                <Header as='h4'>
                                    {key.school + ' - ' + key.area}
                                </Header>
                                <p>{'Period:' + key.period}</p>
                                <p>{"GPA:" + key.gpa }</p>
                                {key.courses.map(course => (
                                    <Label key={course}>{course}</Label>
                                ))}
                            </Grid.Column>
                        </Grid.Row>
                    );
                })}
            </Grid>
        )
    }
    render() {
        const schoolDom = this.SchoolInfo();
        return (
            <Card id='education' fluid>
                <Card.Content>
                    <Card.Header textAlign='left'>Education</Card.Header>
                </Card.Content>
                <Card.Content>
                    {schoolDom}
                </Card.Content>
            </Card>
        );
    }
}


// WEBPACK FOOTER //
// ./src/Infos/education.js